<template>
  <header
    ref="headerRef"
    class="header"
    :class="{
      'fixedHeader': fixedHeader
    }"
  >
    <div
      class="headerBlock"
    >
      <div class="headerBlockMain js-isNotOverflowAuto">
        <div class="container">
          <button
            v-if="layout !== 'cart' && !hideWidget(confWidgets.header.navigation)"
            :class="{ 'active': showHeaderMobileMenu }"
            class="sidenav-trigger hamburger hamburger-squeeze hide-on-large-only"
            type="button"
            aria-label="menuButton"
            @click="showHeaderMobileMenu = isNotOverflow = isShowOverlay = !showHeaderMobileMenu"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>

          <span class="logo-container">
            <NuxtLink
              to="/"
              :title="confMain.siteDescr"
              class="logo left"
            >
              <img
                :alt="confMain.siteDescr"
                src="/img/logo-slogan.svg"
                class="responsive-img"
                height="78"
                width="300"
              />
            </NuxtLink>

            <div
              id="productLogo"
              class="onlyFixedBlock"
            >
              <NuxtLink
                to="/"
                :title="confMain.siteDescr"
                class="logo-simple left"
              >
                <nuxt-picture
                  preload
                  loading="lazy"
                  :img-attrs="{class: 'responsive-img', alt: ''}"
                  src="/img/logo-simple.svg"
                  height="78"
                  width="300"
                  quality="80"
                  :placeholder="[100]"
                  sizes=""
                />
              </NuxtLink>
            </div>
          </span>

          <div class="main-menu right right-align nav-links">
            <div
              v-if="layout === 'cart' && !hideWidget(confWidgets.header.info)"
              class="freeShipping green-text text-darken-1 hide-on-med-and-down"
            >
              <i class="freeShipping__icon icon icon-spaceship green-text text-lighten-2 hide-on-med-and-down"></i>
              <div
                class="freeShipping__descr"
                v-html="$t('freeShippingDescr')"
              ></div>
            </div>

            <div
              v-if="confMain.email && layout !== 'cart'"
              class="oc-hide hide-on-med-and-down"
            >
              <a
                class="contact email"
                :href="`mailto:${confMain.email}`"
                :title="$t('emailSite', { siteName: confMain.siteName })"
              >
                <i class="icon icon-mail left"></i>
                <span class="left">
                  {{ confMain.email }}
                </span>
              </a>
            </div>

            <div
              v-if="confMain.phone"
              class="hide-on-small-only phone"
            >
              <a
                class="contact phone"
                :href="`tel:${confMain.phone?.replace(/\D+/g, '')}`"
                :title="$t('callTollFree')"
              >
                <i class="icon icon-phone left"></i>
                <span class="left">
                  {{ confMain.phone }}
                </span>
              </a>
            </div>

            <template v-if="!hideWidget(confWidgets.header.info)">
              <div>
                <a
                  href="#"
                  class="pubble-cw-contactbot item"
                  role="button"
                  title="Client Advisor"
                  @click="e => e.preventDefault()"
                >
                  <span class="icon">
                    <svg
                      id="Layer_1"
                      width="21"
                      height="21"
                      xmlns="http://www.w3.org/2000/svg"
                      data-name="Layer 1"
                      viewBox="0 0 122.88 108.25"
                    >
                      <defs></defs>
                      <path
                        class="cls-1"
                        d="M51.16,93.74c13,12.49,31.27,16.27,49.59,8.46l15.37,6L111,96.13c17.08-13.68,14-32.48,1.44-45.3a44.38,44.38,0,0,1-4.88,13.92A51.45,51.45,0,0,1,93.45,80.84a62.51,62.51,0,0,1-19.73,10,71.07,71.07,0,0,1-22.56,2.92ZM74.74,36.13a6.68,6.68,0,1,1-6.68,6.68,6.68,6.68,0,0,1,6.68-6.68Zm-44.15,0a6.68,6.68,0,1,1-6.68,6.68,6.68,6.68,0,0,1,6.68-6.68Zm22.08,0A6.68,6.68,0,1,1,46,42.81a6.68,6.68,0,0,1,6.68-6.68ZM54,0H54c14.42.44,27.35,5.56,36.6,13.49,9.41,8.07,15,19,14.7,31v0c-.36,12-6.66,22.61-16.55,30.11C79,82.05,65.8,86.4,51.38,86a64.68,64.68,0,0,1-11.67-1.4,61,61,0,0,1-10-3.07L7.15,90.37l7.54-17.92A43.85,43.85,0,0,1,4,59,36.2,36.2,0,0,1,0,41.46c.36-12,6.66-22.61,16.55-30.12C26.3,4,39.53-.4,54,0ZM53.86,5.2h0C40.59,4.82,28.52,8.77,19.69,15.46,11,22,5.5,31.28,5.19,41.6A31.2,31.2,0,0,0,8.61,56.67a39.31,39.31,0,0,0,10.81,13L21,70.87,16.68,81.05l13.08-5.14,1,.42a55.59,55.59,0,0,0,10.05,3.18A59,59,0,0,0,51.52,80.8c13.22.39,25.29-3.56,34.12-10.26C94.31,64,99.83,54.73,100.15,44.4v0c.3-10.32-4.65-19.85-12.9-26.92C78.85,10.26,67.06,5.6,53.87,5.2Z"
                      />
                    </svg>
                  </span>
                </a>
              </div>

              <div>
                <a
                  href="/search"
                  role="button"
                  title="Search"
                  @click="($e) => {
                    $e.preventDefault()
                    
                    drawerOptions.search = {
                      componentId: 'FormsGroupSearch',
                      header: $t('search'),
                      buttons: false,
                      options: {
                        position: 'top'
                      },
                      returnData: () => { }
                    }
                  }"
                >
                  <span>
                    <i class="icon icon-zoom"></i>
                  </span>
                </a>
              </div>

              <ClientOnly>
                <div
                  v-if="$member?.isMember?.value"
                  class="cart"
                >
                  <NuxtLink
                    v-if="confCart.cartEnable"
                    :title="$t('cart')"
                    to="/cart"
                  >
                    <span>
                      <i class="icon icon-shopping-cart"></i>
                      <span
                        v-if="$member?.user?.value?.cart_items_count" 
                        class="count"
                      >{{ $member?.user?.value?.cart_items_count }}</span>
                    </span>
                  </NuxtLink>

                  <NuxtLink
                    v-else
                    :title="$t('checkout')"
                    to="/checkout"
                  >
                    <span>
                      <i class="icon icon-shopping-cart"></i>
                      <span
                        v-if="$member?.user?.value?.cart_items_count" 
                        class="count"
                      >{{ $member?.user?.value?.cart_items_count }}</span>
                    </span>
                  </NuxtLink>
                </div>
              </ClientOnly>

              <div
                :class="{ 'hover': showSub === 'customer' }"
                @mouseover="onMouseOver('customer')"
                @mouseleave="onMouseLeave"
              >
                <NuxtLink
                  v-if="$member?.isMember?.value && $member?.customerRoutes"
                  to="/customer/projects"
                  :title="$t('account')"
                  class="account-link"
                >
                  <span>
                    <i class="icon icon-account left"></i>
                  </span>
                </NuxtLink>

                <a
                  v-else
                  href="/customer/projects"
                  :title="$t('signIn')"
                  class="account-link"
                  @click="($e) => {
                    $e.preventDefault()
                    
                    drawerOptions.entry = {
                      typeId: 'entry',
                      componentId: 'WidgetsSystemEntry',
                      header: $t('signIn'),
                      buttons: false,
                      typeForm: 'login',
                      returnData: () => { }
                    }
                  }"
                >
                  <span>
                    <i class="icon icon-account left"></i>
                  </span>
                </a>

                <ClientOnly>
                  <div
                    v-if="$member?.isMember?.value && $member?.customerRoutes"
                    class="subMenu absolute dropdown-content hide-on-med-and-down"
                  >
                    <div
                      class="inner-wrapper"
                    >
                      <ul class="drop-list">
                        <template v-for="route in $member?.customerRoutes">
                          <li
                            v-if="route.enable && route.important"
                            :key="route"
                            :class="{ active: route.active }"
                          >
                            <NuxtLink :to="route.link">
                              {{ route.title }}
                            </NuxtLink>
                          </li>
                        </template>
                        <li class="divider"></li>
                        <li>
                          <NuxtLink
                            :title="$t('logOut')"
                            class=""
                            @click="$e => {
                              $member.logout()
                              $e.preventDefault()
                            }"
                          >
                            {{ $t('logOut') }}
                          </NuxtLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ClientOnly>
              </div>

              <div
                v-if="confMain.enableMultiLang"
                class="localization"
                :class="{ 'hover': showSub === 'customer' }"
                @mouseover="onMouseOver('customer')"
                @mouseleave="onMouseLeave"
              >
                <a
                  role="button"
                >
                  <span>
                    <i
                      class="icon icon-pin-3"
                      :class="lang"
                    >&nbsp;</i>
                  </span>
                </a>

                <div
                  class="subMenu absolute dropdown-content"
                >
                  <div
                    v-for="locale in $i18n.availableLocales"
                    :key="locale"
                  >
                    <a :href="('//' + (locale !== 'en' ? locale + '.' : '') + host)">
                      <i
                        class="icon icon-pin-3"
                        :class="locale"
                      >&nbsp;</i>
                      <span>{{ $i18n.messages.value[locale].locale }}</span>
                    </a>
                  </div>
                </div>
              </div>

              <div
                v-if="layout === 'product'"
                id="customizeNow"
                class="onlyFixedBlock productInfo hide-on-med-and-down"
              ></div>
            </template>
          </div>
        </div>
      </div>
      
      <HeaderNavigation v-if="!hideWidget(confWidgets.header.navigation)" />

      <HeaderAnnouncement v-if="!hideWidget(confWidgets.header.announcement)" />
    </div>
  </header>
</template>

<script setup>
const { $member } = useNuxtApp()
const { confMain, confCart, confWidgets } = useConfig()
const { hideWidget } = useWidgets()

const { headerRef, showHeaderMobileMenu, isNotOverflow, isShowOverlay, layout, lang, host } = useHelpers()
const { drawerOptions } = usePopups()

const fixedHeader = ref(false)
const showSub = ref(false)

/**
* Main Logic
*/
onMounted(function () {
  // Fixed header after scroll
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 80) {
      fixedHeader.value = true
    } else {
      fixedHeader.value = false
    }
  })
})

/**
* SubMenu
*/
let timeoutId = null
const onMouseOver = (id) => {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }
  showSub.value = id
}

const onMouseLeave = () => {
  timeoutId = setTimeout(() => {
    showSub.value = false
  }, 100)
}
</script>

<style lang="scss" scoped>
.header {
  .logo-container {
    display: flex;
    align-items: center;
  }

  .logo,
  .logo-simple {
    display: flex;
    align-items: center;
    min-width: 130px;
    max-width: 240px;
    font-size: 0;

    img {
      box-sizing: content-box;
      width: 100%;
      height: 36px;
      padding: .25rem 0;
      @media only screen and (min-width: 601px) {
        height: 48px;
        padding: .25rem 0;
      }
      @media only screen and (min-width: 993px) {
        height: 64px;
        padding: .5rem 0;
      }
    }
  }

  /*
  * Logo Compaign
  */
  .logo-compaign {
    margin: 0 1rem;
    img {
      width: 100%;
      max-width: 120px;
      height: 100%;
      max-height: 45px;
    }
    &.is-reverse {
      display: none;
    }
  }

  .onlyFixedBlock {
    display: none;
  }
  .freeShipping {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 1rem;
    margin: 0 auto;
    font-size: 1rem;
    line-height: 16px;
    text-align: center;
    &__icon {
      padding-right: .5rem;
    }
    &__descr {
      text-align: left;
    }
    @media only screen and (max-width: 1050px) {
      font-size: 11px;
    }
  }
  .headerBlock {
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    & > .progress {
      position: absolute;
      top: 0;
    }
    .headerBlockMain {
      z-index: 999;
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      background: #fff;
      border-bottom: 1px solid #ebedf0;
      @media only screen and (max-width: 992px) {
        height: 70px;
      }
      @media only screen and (max-width: 768px) {
        padding: .5rem 0;
      }
      & > .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 1rem;
      }
    }
    .main-menu {
      display: flex;
      justify-content: right;
      align-items: center;
      flex: 1 1 auto;
      margin: 0 -.5rem 0 0;
      & > div {
        position: relative;
        font-weight: 500;
        cursor: pointer;
        .subMenu {
          top: 40px;
          right: 0;
          left: inherit;
          display: none;
          width: calc(100% + 2rem);
          max-height: inherit;
          background-color: #fff !important;
          box-shadow: 0 8px 24px 3px rgb(0 46 76 / 5%);
          border-radius: 0 0 3px 3px;
          transform-origin: top center !important;
          opacity: 0;
          &:after {
            content: "";
            position: absolute;
            top: -30px;
            left: 0;
            z-index: 1;
            display: block;
            width: 100%;
            height: 30px;
            background: transparent;
          }
        }
        &.hover {
          .subMenu {
            display: block;
            animation: showBlock .2s linear forwards;
            opacity: 1;
          }
        }
        &.productInfo {
          padding-right: .7rem;
        }
        & > a,
        & > span.item {
          position: relative;
          display: flex;
          align-items: center;
          padding: 0 0;
          color: #015287;
          font-size: 13px;
          text-align: left;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            display: block;
            width: 100%;
            background: transparent;
          }
          i {
            width: 20px;
            margin-right: 0;
            color: #09f;
            font-size: 20px;
          }

          svg {
            fill: #09f;
          }

          span {
            display: flex;
            align-items: center;
            padding: 0 1rem;
          }
          &:hover {
            color: #09f;
            background: transparent;
          }
        }
        &:not(:last-child):not(.localization) {
          &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 1.625rem;
            background-color: #eaedf0;
            transform: translateY(-50%);
          }
        }
        &.phone {
          flex: 0 0 auto;
          padding-left: 1rem;
          span {
            padding: 0 1rem;
          }
        }
        &.cart {
          position: relative;
          .count {
            position: absolute;
            top: -6px;
            right: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 16px;
            padding: 3px;
            color: #fff;
            font-size: 10px;
            font-weight: 300;
            line-height: 1;
            background: color("primary-color", "base");
            border: 1px solid #fff;
            border-radius: 50%;
          }
        }
        &.localization {
          .icon {
            display: block;
            width: 18px;
            height: 18px;
            &.en {
              background: url("/assets/general/img/lang-us.svg") center center no-repeat;
              background-size: 100%;
            }
            &.ga {
              background: url("/assets/general/img/lang-ir.svg") center center no-repeat;
              background-size: 100%;
            }
          }
        }
        .dropdown-content {
          min-width: 170px;
          div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            min-height: 1.5rem;
            line-height: 1.5rem;
            .drop-list {
              width: 100%;
            }
            a {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              min-height: 1.5rem;
              padding: .5rem 1rem;
              font-size: 11px;
              line-height: 1.5rem;
              &:hover {
                color: color("primary-color", "base-2");
                background-color: rgba(1, 82, 135, .05);
              }
            }
            i {
              flex: 0 1 22px;
              width: 22px;
              height: 22px;
              margin: 0;
            }
            span {
              padding: 0 0 0 10px;
              font-size: 11px;
              line-height: 1rem;
              text-align: left;
            }
            &:hover {
              background-color: initial;
            }
          }
        }
      }
    }
  }

  /**
  * Sidenav Trigger
  */
  .sidenav-trigger {
    position: relative;
    width: 1.7rem;
    height: 2.5rem;
    padding: 0;
    margin-right: 1rem;
    background: transparent;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: .7;
    }
    .hamburger-inner {
      top: 50%;
      display: block;
      margin-top: -2px;

      &::before,
      &::after {
        content: "";
        display: block;
      }
      &::before {
        top: -8px;
      }
      &::after {
        bottom: -8px;
      }
    }
    .hamburger-inner,
    .hamburger-inner::before,
    .hamburger-inner::after {
      position: absolute;
      width: 1.7rem;
      height: 2px;
      background-color: color("primary-color", "base-2");
      border-radius: 4px;
      transition-duration: .15s;
      transition-property: transform;
      transition-timing-function: ease;
    }
    &.active {
      .hamburger-inner {
        transform: rotate(45deg);
        transition-delay: .12s;
        transition-timing-function: cubic-bezier(.215, .61, .355, 1);
        &:before {
          top: 0;
          transition: top .075s ease, opacity .075s .12s ease;
          opacity: 0;
        }
        &:after {
          bottom: 0;
          transform: rotate(-90deg);
          transition: bottom .075s ease,-webkit-transform .075s .12s cubic-bezier(.215, .61, .355, 1);
          transition: bottom .075s ease,transform .075s .12s cubic-bezier(.215, .61, .355, 1);
          transition: bottom .075s ease,transform .075s .12s cubic-bezier(.215, .61, .355, 1),-webkit-transform .075s .12s cubic-bezier(.215, .61, .355, 1);
        }
      }
    }
  }

  &.fixedHeader {
    padding-top: 170px;
    @media only screen and (max-width: 768px) {
      padding-top: 110px;
    }
    .headerBlock {
      position: fixed;
      top: 0;
      left: 0;
      box-shadow: 0 -16px 26px rgba(0, 0, 0, .4);
      animation: showBar ease .5s;
      .mainNavigation {
        display: none;
      }
      .announcement {
        display: none;
      }
    }
    .logo {
      display: none;
    }
    .onlyFixedBlock {
      display: flex;
    }
    #productLogo {
      & > * {
        display: none;
        &:last-child {
          display: flex;
        }
      }
    }
  }
  @-webkit-keyframes showBar {
    from {
      transform: translate3d(0, -100%, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes showBar {
    from {
      transform: translate3d(0, -100%, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  /*
  * Product Info
  */
  &:deep(.productInfo) {
    display: flex;
    align-items: center;
    .productInfo {
      &__logo {
        height: 50px;
        margin-right: .5rem;
        @media only screen and (min-width: 993px) {
          height: 60px;
        }
      }
      &__title {
        margin: 0;
        font-weight: 600;
      }
      .btn-holder {
        .btn {
          min-width: auto;
        }
      }
    }
  }
}
</style>
